export const state = () => ({
    authors: [],
});
